import { motion, useReducedMotion } from "framer-motion";
import { BOOKING_URL, IMAGES } from "@/lib/site";
import { MaskedLine } from "@/components/Reveal";

const ease = [0.22, 1, 0.36, 1];

const Booking = () => {
  const reduced = useReducedMotion();
  return (
    <section
      data-chapter="07"
      data-testid="booking-section"
      className="relative overflow-hidden bg-forest py-32 text-ivory lg:py-44"
    >
      <div className="relative mx-auto flex max-w-4xl flex-col items-center px-6 text-center">
        <motion.div
          className="relative inline-block"
          initial={{ opacity: 0, y: reduced ? 0 : 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 1.1, ease }}
        >
          <span className="font-serif text-7xl font-light text-gold" aria-hidden="true">R</span>
          <span className="absolute -top-1 left-[38%] h-1.5 w-1.5 rounded-full bg-accent" aria-hidden="true" />
        </motion.div>

        <h2 className="mt-12 font-serif text-5xl font-light leading-[1.02] tracking-tight sm:text-6xl lg:text-7xl" data-testid="booking-headline">
          <MaskedLine delay={0.1}>Ready to</MaskedLine>
          <MaskedLine delay={0.25}>
            <span className="italic text-sand">exhale</span>
            <span className="mb-2 ml-3 inline-block h-2 w-2 rounded-full bg-gold align-baseline" />
          </MaskedLine>
        </h2>

        <motion.p
          className="mt-10 max-w-md font-sans text-base font-light leading-relaxed tracking-wide text-ivory/75"
          initial={{ opacity: 0, y: reduced ? 0 : 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 1.1, delay: 0.5, ease }}
          data-testid="booking-copy"
        >
          Leave the day at the door. This time is yours.
        </motion.p>

        <motion.a
          href={BOOKING_URL}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="booking-cta-button"
          className="group mt-14 flex items-center gap-4 rounded-full border border-gold px-12 py-5 font-sans text-xs font-medium uppercase tracking-[0.32em] text-ivory transition-colors duration-500 hover:bg-gold/15"
          initial={{ opacity: 0, y: reduced ? 0 : 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 1.1, delay: 0.65, ease }}
        >
          Book your session
          <span className="h-[5px] w-[5px] rounded-full bg-gold transition-transform duration-500 group-hover:translate-x-1" />
        </motion.a>

        <motion.p
          className="mt-6 font-sans text-[10px] uppercase tracking-[0.3em] text-ivory/40"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 1, delay: 0.85 }}
        >
          You will be redirected to our secure booking system
        </motion.p>
      </div>
    </section>
  );
};

export default Booking;
